import { Routes } from '@angular/router';
import { Login } from './features/login/login';
import { Home } from './features/home/home';
import { Code } from './features/login/code/code';
import { LoginGuard } from './core/guards/login.guards';
import { AuthGuard } from './core/guards/auth.guard';
import { MsalGuard } from '@azure/msal-angular';
import { WmxUserGuard } from './shared/guards/wmx.guard';
import { ACUserGuard } from './shared/guards/ac.guard';
import { FgContainerResolver } from './features/finished-goods/components/fg-container/fg-container.resolver';
import { FGUserGuard } from './shared/guards/fb.guard';
import { SelectBusinessUnit } from './features/select-business-unit/select-business-unit';
import { configuratorGuard } from './core/guards/configurator-guard';

export const routes: Routes = [
  {
    path: '',
    component: Login,
    canActivate: [LoginGuard],
  },
  {
    component: Code,
    matcher: (url) => {
      return url.length === 1 && url[0].path.startsWith('code') ? { consumed: url } : null;
    },
    canActivate: [LoginGuard],
  },
  {
    path: 'select-business-unit',
    canActivate: [AuthGuard],
    component: SelectBusinessUnit,
  },
  // {
  //   path: 'home',
  //   component: Home,
  //   canActivate: [AuthGuard, MsalGuard],
  // },
  {
    path: 'finished-goods',
    loadChildren: () =>
      import('./features/finished-goods/finished-goods.routes').then((m) => m.fgRoutes),
    canActivate: [AuthGuard, FGUserGuard],
  },
  {
    path: 'work-instruction',
    loadChildren: () =>
      import('./features/work-instruction/work-instruction.routes').then((m) => m.wiRoutes),
    canActivate: [AuthGuard, ACUserGuard],
  },
  {
    path: 'so',
    loadChildren: () =>
      import('./features/sales-order/sales-order.routes').then((m) => m.SalesRoutes),
    canActivate: [AuthGuard, WmxUserGuard],
  },

  {
    path: 'vas-configurator',
    loadChildren: () =>
      import('./features/configurator/vas-configurator.route').then((c) => c.VasConfiguratorRoutes),
    canActivate: [AuthGuard, configuratorGuard],
  },
  {
    path: 'host-app',
    loadComponent: () => import('./features/demo/host-app/host-app').then((c) => c.HostApp),
    canActivate: [AuthGuard],
  },
];
